// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` html {
    color: #646464;
    margin: 0;
    padding: 0;

}

body {
    padding: 0;
    margin: 0;
    background-color: #000000;
    font-family: Geometria, "Gill Sans", sans-serif;
    font-size: 14px;
}


.page0wrapper {
    height: 300vh;
    background-color: #010d4d;
}
.page0Arrow {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 16px;
}
.stageWrapper {
    position: fixed;
    left: 0;
    top: 0;
}
.menuWrapper {
    height: 200vh;
    background-color: #010d4d;
}

.menuContent {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 10;
}
.menuLogo {
    position: absolute;
    left: 163px;
    width: 394px;
    height: 62px;
}

.menuItems {
    display: flex;
    flex-direction: row;
    width: 81vw;
    align-items: center;
    justify-content: flex-end;
}
.menuItems a {
    color: aliceblue;
    padding: 33px 17px;
    text-decoration: none;
    font-weight: 100;
}
.main-page_sloagan {
    position: absolute;
    left: 15vw;
    top: 25vh;
    width: 70vw;
    color: white;
    font-size: 14rem;
    font-weight: 700;
    letter-spacing: 0.015em;
    line-height: 1.31em;
}
.main-page_sloagan-link {
    padding-top: 34px;
    font-size: 34pt;
    line-height: 1em;
    padding-left: 6px;
}
.main-page_sloagan-link a {
    font-size: 26pt;
    color: white;
    text-decoration: none;
    font-weight: 100;
    letter-spacing: 0.015em;
}
.main-page_sloagan-link div {
    padding-top: 34px;
} 
.main-page_sloagan-link a div {
    padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"CAAC;IACG,cAAc;IACd,SAAS;IACT,UAAU;;AAEd;;AAEA;IACI,UAAU;IACV,SAAS;IACT,yBAAyB;IACzB,+CAA+C;IAC/C,eAAe;AACnB;;;AAGA;IACI,aAAa;IACb,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,YAAY;AAChB;AACA;IACI,eAAe;IACf,OAAO;IACP,MAAM;AACV;AACA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,OAAO;IACP,MAAM;IACN,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,yBAAyB;AAC7B;AACA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,UAAU;AACd","sourcesContent":[" html {\n    color: #646464;\n    margin: 0;\n    padding: 0;\n\n}\n\nbody {\n    padding: 0;\n    margin: 0;\n    background-color: #000000;\n    font-family: Geometria, \"Gill Sans\", sans-serif;\n    font-size: 14px;\n}\n\n\n.page0wrapper {\n    height: 300vh;\n    background-color: #010d4d;\n}\n.page0Arrow {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: fixed;\n    bottom: 16px;\n}\n.stageWrapper {\n    position: fixed;\n    left: 0;\n    top: 0;\n}\n.menuWrapper {\n    height: 200vh;\n    background-color: #010d4d;\n}\n\n.menuContent {\n    position: fixed;\n    left: 0;\n    top: 0;\n    z-index: 10;\n}\n.menuLogo {\n    position: absolute;\n    left: 163px;\n    width: 394px;\n    height: 62px;\n}\n\n.menuItems {\n    display: flex;\n    flex-direction: row;\n    width: 81vw;\n    align-items: center;\n    justify-content: flex-end;\n}\n.menuItems a {\n    color: aliceblue;\n    padding: 33px 17px;\n    text-decoration: none;\n    font-weight: 100;\n}\n.main-page_sloagan {\n    position: absolute;\n    left: 15vw;\n    top: 25vh;\n    width: 70vw;\n    color: white;\n    font-size: 14rem;\n    font-weight: 700;\n    letter-spacing: 0.015em;\n    line-height: 1.31em;\n}\n.main-page_sloagan-link {\n    padding-top: 34px;\n    font-size: 34pt;\n    line-height: 1em;\n    padding-left: 6px;\n}\n.main-page_sloagan-link a {\n    font-size: 26pt;\n    color: white;\n    text-decoration: none;\n    font-weight: 100;\n    letter-spacing: 0.015em;\n}\n.main-page_sloagan-link div {\n    padding-top: 34px;\n} \n.main-page_sloagan-link a div {\n    padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
